import { Link } from "react-router-dom";

export default function PageHero({ overline, title, lead, image, primaryCta, secondaryCta }) {
  return (
    <section className="relative pt-10 pb-16 sm:pt-16 sm:pb-24" data-testid="page-hero">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6 animate-fade-up">
          {overline && (
            <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-[#7A1F1F] mb-5">
              {overline}
            </p>
          )}
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#1A1710]">
            {title}
          </h1>
          {lead && (
            <p className="mt-6 text-lg sm:text-xl text-[#6B5F4A] leading-relaxed max-w-xl">
              {lead}
            </p>
          )}
          {(primaryCta || secondaryCta) && (
            <div className="mt-8 flex flex-wrap gap-3">
              {primaryCta && (
                <Link
                  to={primaryCta.to}
                  data-testid="page-hero-primary-cta"
                  className="inline-flex bg-[#7A1F1F] text-white hover:bg-[#5C1717] rounded-full px-7 py-3.5 text-sm font-semibold transition-colors"
                >
                  {primaryCta.label}
                </Link>
              )}
              {secondaryCta && (
                <Link
                  to={secondaryCta.to}
                  data-testid="page-hero-secondary-cta"
                  className="inline-flex border border-[#1A1710]/20 text-[#1A1710] hover:border-[#7A1F1F] hover:text-[#7A1F1F] rounded-full px-7 py-3.5 text-sm font-semibold transition-colors"
                >
                  {secondaryCta.label}
                </Link>
              )}
            </div>
          )}
        </div>
        <div className="lg:col-span-6 animate-fade-up delay-200">
          <div className="relative aspect-[4/5] sm:aspect-[5/6] rounded-3xl overflow-hidden shadow-md">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5 rounded-3xl pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
}
